const calendarInitialState = {
    selectedDate: null,
    activeMonth: null,
    activeYear: null,
};

export default calendarInitialState;